/**
 * Created by Pradeep Kumar on 05/23/2019.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TweenLite} from "gsap";
import {TombOfNefertitiSoundConfig} from "../../TombOfNefertitiSoundConfig";
import {TombOfNefertiti} from "../../TombOfNefertiti";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class TombOfNefertitiFreeSpinIntroView extends ScreenView {

    static readonly FREESPIN_INTRO_TRANSITION_IN:string = 'transitIntoFreeSpins';
    static readonly PLAY_SCATTER_ANIMATION:string = 'playScatterAnimatiuon';
    static readonly FREESPIN_INTRO_SHOW_BANNER:string = 'showFSIntroBanner';
    static readonly FREESPIN_INTRO_REVEAL_REELS:string = 'revealFSReels';
    static readonly FREESPIN_INTRO_REVEAL_BETLINES:string = 'freespinIntroRevealBetline';
    static readonly FREESPIN_INTRO_TRANSITION_IN_COMPLETE:string = 'transitIntoFreeSpinsComplete';

    private presentationCompleteCallback:any;
    private introCompleteCallback:any;

    private _container:PIXI.Container;

    protected createGameGraphics():PIXI.DisplayObject {
        const container:PIXI.Container = new PIXI.Container(),
            textContainer:PIXI.Container = new PIXI.Container(),
            textStyle:TextStyleOptions = {
                fill : 0x381600,
                fontFamily : "Open Sans",
                wordWrap : true,
                padding : 20,
                wordWrapWidth : 350,
                fontSize : 30,
                fontWeight : "bold",
                breakWords : true
            },
            banner:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("SplashMap")[0]),
            multiplier:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("RaiderSpins_Multiplier")[0]),
            title:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("RaiderSpins")[0]);

        multiplier.name="introBGImg";
        banner.scale.set(1.06);

        banner.anchor.set(0.5);
        multiplier.anchor.set(0.5);
        title.anchor.set(0.5);

        multiplier.position.set(-220, 40);
        title.position.set(0, -240);

        container.alpha = 0;

        container.addChild(banner);
        container.addChild(multiplier);
        container.addChild(title);

        let guaranteedWild = new PIXI.Text(Translation.translate("Guaranteed Wild on every spin!"), textStyle),
            increaseMultiplier = new PIXI.Text(Translation.translate("Increase multiplier with every win!"), textStyle),
            extraBonus = new PIXI.Text(Translation.translate("Each extra Bonus symbol awards +1 spin!"), textStyle);

        const yGap:number = 15;

        textContainer.addChild(guaranteedWild);
        textContainer.addChild(increaseMultiplier);
        textContainer.addChild(extraBonus);

        increaseMultiplier.y = guaranteedWild.y + guaranteedWild.height + yGap;
        extraBonus.y = increaseMultiplier.y + increaseMultiplier.height + yGap;

        textContainer.x = 75;
        textContainer.y = -170;

        container.addChild(textContainer);
        this._container = container;

        if (TombOfNefertiti.api.gameClientConfiguration.isSet) {
            this._container.children.forEach((item) => {
                if (item.name === "introBGImg") {
                    if (!TombOfNefertiti.api.gameClientConfiguration.showLowProbabilityGfx) {
                        (<PIXI.Sprite>item).texture = GameResources.getTextures("RaiderSpins_Multiplier_US")[0];
                    }
                }
            });
        } else {
            TombOfNefertiti.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION, () => {
                this._container.children.forEach((item) => {
                    if (item.name === "introBGImg") {
                        if (!TombOfNefertiti.api.gameClientConfiguration.showLowProbabilityGfx) {
                            (<PIXI.Sprite>item).texture = GameResources.getTextures("RaiderSpins_Multiplier_US")[0];
                        }
                    }
                });
            });
        }


        return container;
    }

    protected startPresentation(data?:ParsedServerData, onShowComplete?:() => void):void {
        this._button.visible = false;
        this.presentationCompleteCallback = onShowComplete;

        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiFreeSpinIntroView.PLAY_SCATTER_ANIMATION));
    }

    protected addEventListeners():void {
        super.addBaseEventListeners();
        EventHandler.addEventListener(this, TombOfNefertitiFreeSpinIntroView.FREESPIN_INTRO_SHOW_BANNER, () => {
            this.showBanner()
        });
        EventHandler.addEventListener(this, TombOfNefertitiFreeSpinIntroView.FREESPIN_INTRO_TRANSITION_IN_COMPLETE, () => {
            this.onIntroPresentationComplete()
        });
    }

    protected stopPresentation(closeCallback?:() => void):void {
        this.introCompleteCallback = closeCallback;
        this._button.visible = false;

        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiFreeSpinIntroView.FREESPIN_INTRO_TRANSITION_IN, 'OUT'));
        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiFreeSpinIntroView.FREESPIN_INTRO_REVEAL_REELS));

        TweenLite.to(this._container, 0.8, {alpha : 0});
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        super.onResizeGameGraphics && super.onResizeGameGraphics(resizeData);

        this._container.x = this._screenWidth / 2;
        this._container.y = this._screenHeight / 2;
    }

    private onIntroPresentationComplete():void {
        super.stopPresentation(this.introCompleteCallback);
    }

    private showBanner():void {
        const duration:number = 1.5;

        this._container.alpha = 0;

        SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.FS_INTRO_PAPER_OPEN);

        TweenLite.to(this._container, duration, {
            alpha : 1, onComplete : () => {
                this.addContinueButton()
            }
        });
    }

    private addContinueButton():void {
        this._button.visible = true;
        this.presentationCompleteCallback();
    }
}